export default __webpack_public_path__ + "static/media/lucky-spin-banner-vn.52edb87f.webp";